import { EmailOutlined, FolderOutlined, GroupOutlined } from '@mui/icons-material';
import React from 'react';
import IAppNavigation from '../../../../../app/features/navigation/interfaces/IAppNavigation';
import langAdminNavigation from '../../../langs/langAdminNavigation';

const navAdmin: IAppNavigation[] = [
	{
		id: 'admin_investors_list',
		routeTag: 'admin_investors_list',
		routeParams: null,
		title: langAdminNavigation.investor_list.tag,
		type: 'item',
		icon: <GroupOutlined />,
		children: null,
	},
	{
		id: 'admin_document_access',
		// routeTag: 'admin_document_access',
		// routeParams: null,
		title: langAdminNavigation.document_access.tag,
		type: 'collapse',
		icon: <FolderOutlined />,
		children: [
			{
				id: 'admin_document_access_logs',
				routeTag: 'admin_document_access_logs',
				routeParams: null,
				title: langAdminNavigation.document_access_logs.tag,
				type: 'item',

				children: null,
			},
			{
				id: 'admin_document_access_capital_calls',
				routeTag: 'admin_document_access_capital_calls',
				routeParams: null,
				title: langAdminNavigation.admin_document_access_capital_calls.tag,
				type: 'item',

				children: null,
			},
		],
	},
	{
		id: 'admin_email_notifications',
		// routeTag: 'admin_email_notifications',
		// routeParams: null,
		title: langAdminNavigation.admin_email_notifications.tag,
		type: 'collapse',
		icon: <EmailOutlined />,
		children: [
			{
				id: 'admin_email_notifications',
				routeTag: 'admin_email_notifications',
				routeParams: null,
				title: langAdminNavigation.admin_email_notifications_list.tag,
				type: 'item',

				children: null,
			},
			{
				id: 'admin_document_email_notifications',
				routeTag: 'admin_document_email_notifications',
				routeParams: null,
				title: langAdminNavigation.admin_document_email_notifications.tag,
				type: 'item',

				children: null,
			},
			{
				id: 'admin_user_email_notifications',
				routeTag: 'admin_user_email_notifications',
				routeParams: null,
				title: langAdminNavigation.admin_user_email_notifications.tag,
				type: 'item',

				children: null,
			},
			{
				id: 'admin_notification_monitoring',
				routeTag: 'admin_notification_monitoring',
				routeParams: null,
				title: langAdminNavigation.admin_notification_monitoring.tag,
				type: 'item',

				children: null,
			},
		],
	},
];

export default navAdmin;
